import { Menu, MenuItem, PopoverPosition } from "@mui/material";
import { mixpanel } from "common/analytics";
import { useTranslation } from "common/locales";
import { GeneralFeedPurchaseEvent } from "model";
import { Dispatch, SetStateAction } from "react";

interface Props {
  feedPurchaseEvent: GeneralFeedPurchaseEvent;
  anchor: HTMLElement | null;
  anchorPosition?: PopoverPosition;
  close: () => void;
  setDialogOpen: Dispatch<SetStateAction<boolean>>;
}
export default function FeedPurchaseEventMoreMenu({
  feedPurchaseEvent,
  anchor,
  anchorPosition,
  close,
  setDialogOpen,
}: Props) {
  const { t } = useTranslation();
  return (
    <Menu
      anchorEl={anchor}
      anchorPosition={anchorPosition}
      anchorReference={
        anchor ? "anchorEl" : anchorPosition ? "anchorPosition" : "none"
      }
      open={anchor ? anchor.id === feedPurchaseEvent.guid : false}
      onClose={close}
      key={`fe-menu-${feedPurchaseEvent.guid}`}
    >
      <MenuItem
        key={`fe-menuitem-edit-${feedPurchaseEvent.guid}`}
        onClick={() => {
          mixpanel.track("Edit/view feed purchase event clicked");
          setDialogOpen(true);
          close();
        }}
      >
        {t("feedPurchaseEvent.menu.editView")}
      </MenuItem>
    </Menu>
  );
}
